module.exports = __webpack_public_path__ + "static/media/riziptApp.22516d93.jpg";